module.exports = __webpack_public_path__ + "media/fuel_types/pb95-6d639fcb.png";